export const formatToLocalDate =(date: string | Date, locale: string): string =>{
    return (new Date(date)).toLocaleString(locale)
}